"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenu = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const TextV2_1 = require("../../foundations/Typography/TextV2");
const DropdownMenu = ({ dropdownOptions, showNoResults = false, noResultsMessage = "No results found", isOpen, selectedOption, onOptionSelect, onDismiss }) => {
    const [highlightedIndex, setHighlightedIndex] = react_1.default.useState(-1);
    const optionRefs = react_1.default.useRef([]);
    optionRefs.current = [];
    const menuRef = react_1.default.useRef(null);
    // focus updated on open
    react_1.default.useEffect(() => {
        if (isOpen && highlightedIndex >= 0) {
            const option = optionRefs.current[highlightedIndex];
            option === null || option === void 0 ? void 0 : option.focus();
        }
    }, [highlightedIndex, isOpen]);
    // focus updated when using keyboard nav
    react_1.default.useEffect(() => {
        var _a;
        if (isOpen) {
            const idx = dropdownOptions.findIndex((opt) => opt.value === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value));
            setHighlightedIndex(idx >= 0 ? idx : -1);
            (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [isOpen, dropdownOptions, selectedOption]);
    if (!isOpen) {
        return null;
    }
    const handleKeyDown = (event) => {
        switch (event.key) {
            case "ArrowDown":
                event.preventDefault();
                setHighlightedIndex((prev) => prev < dropdownOptions.length - 1 ? prev + 1 : 0);
                break;
            case "ArrowUp":
                event.preventDefault();
                setHighlightedIndex((prev) => prev > 0 ? prev - 1 : dropdownOptions.length - 1);
                break;
            case "Enter":
                event.preventDefault();
                if (highlightedIndex !== -1) {
                    onOptionSelect(dropdownOptions[highlightedIndex]);
                }
                break;
            case "Tab":
            case "Escape":
                event.preventDefault();
                onDismiss();
                break;
            default:
                break;
        }
    };
    const setOptionRef = (el, index) => {
        if (el) {
            optionRefs.current[index] = el;
        }
    };
    const dropdownContainerStyles = {
        position: "absolute",
        top: "100%",
        left: 0,
        width: "100%",
        // @ts-ignore
        maxHeight: "250px",
        overflowY: "auto",
        border: "1px solid",
        borderColor: "input-stroke-enabled",
        borderRadius: "radius-2",
        backgroundColor: "input-onSurface",
        boxShadow: "shadow-100",
        zIndex: "dropdown",
        transition: "opacity 200ms ease-out, transform 200ms ease-out, visibility 200ms"
    };
    const dropdownItemContainerStyles = {
        px: "spacing-5",
        py: "spacing-3",
        ":hover": {
            backgroundColor: "surface-brand"
        }
    };
    const dropdownItemStyles = {
        px: "spacing-4",
        py: "spacing-2",
        cursor: "pointer",
        ":active": {
            borderLeft: "3px solid",
            borderColor: "onSurface-brand-primary"
        }
    };
    return (react_1.default.createElement(foundations_1.Box, { sx: dropdownContainerStyles, role: "listbox", ref: menuRef, tabIndex: 0, onKeyDown: handleKeyDown }, dropdownOptions.length > 0 ? (dropdownOptions.map((option, index) => {
        const isHighlighted = index === highlightedIndex;
        const isSelected = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === option.value;
        return (react_1.default.createElement(foundations_1.Box, { key: option.value, role: "option", tabIndex: -1, "aria-selected": isHighlighted, ref: (el) => setOptionRef(el, index), onClick: () => onOptionSelect(option), onMouseEnter: () => setHighlightedIndex(index), sx: Object.assign({}, dropdownItemContainerStyles) },
            react_1.default.createElement(foundations_1.Box, { sx: Object.assign(Object.assign({}, dropdownItemStyles), (isSelected && {
                    borderLeft: "3px solid",
                    borderColor: "onSurface-brand-primary"
                })) },
                react_1.default.createElement(TextV2_1.TextV2, { variant: "body-1-regular", sx: { color: "currentColor" } }, option.label))));
    })) : showNoResults ? (react_1.default.createElement(foundations_1.Box, { role: "option", sx: { padding: "spacing-4", color: "text-incidental" } }, noResultsMessage)) : null));
};
exports.DropdownMenu = DropdownMenu;
//# sourceMappingURL=DropdownMenu.js.map